import React, { useEffect, useState, useRef } from 'react'
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import Button from '@mui/material/Button'

const ConfirmPopup = (props) => {
  const { popupType, popupVisible, popupText, onPopupCancel, onPopupOk } = props

  const [displayModal, setDisplayModal] = useState(false)

  useEffect(() => {
    if (popupVisible) {
      setDisplayModal(true)
    } else {
      setDisplayModal(false)
    }
  }, [popupVisible])

  const handlePopupClose = () => {
    setDisplayModal(false)
    onPopupCancel()
  }

  const handlePopupOk = () => {
    setDisplayModal(false)
    onPopupOk()
  }

  if (popupVisible) {
    return (
      <div
        className='confirm-dialog-main'
        onClick={() => {
          //   handlePopupClose()
        }}
      >
        <div className='confirm-dialog-container'>
          {popupType === 'submit' || popupType === 'recordSave' ? (
            <CheckCircleOutlineRoundedIcon
              style={{
                width: '50px',
                height: '50px',
                color: '#41C54F'
              }}
            />
          ) : (
            <HighlightOffRoundedIcon
              style={{
                width: '50px',
                height: '50px',
                color: '#EE3A24'
              }}
            />
          )}
          <p
            className='confirm-dialog-label1'
            style={{
              color:
                popupType === 'submit' || popupType === 'recordSave'
                  ? '#41C54F'
                  : '#EE3A24'
            }}
          >
            Are you sure ?
          </p>
          <p className='confirm-dialog-label2'>{popupText}</p>
          <div className='confirm-dialog-button-container'>
            <Button
              variant='outlined'
              style={{
                height: '44px',
                width: '134px',
                borderColor:
                  popupType === 'submit' || popupType === 'recordSave'
                    ? '#41C54F'
                    : '#EE3A24',
                color:
                  popupType === 'submit' || popupType === 'recordSave'
                    ? '#41C54F'
                    : '#EE3A24',
                marginRight: '20px',
                borderRadius: '8px'
              }}
              onClick={() => {
                handlePopupClose()
              }}
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              style={{
                height: '44px',
                width: '134px',
                backgroundColor:
                  popupType === 'submit' || popupType === 'recordSave'
                    ? '#41C54F'
                    : '#EE3A24',
                borderRadius: '8px'
              }}
              onClick={() => {
                handlePopupOk()
              }}
            >
              {popupType === 'submit'
                ? 'Complete'
                : popupType === 'reset' || popupType === 'resetPractice'
                ? 'Reset'
                : popupType === 'recordSave'
                ? 'Save'
                : 'Delete'}
            </Button>
          </div>
        </div>
      </div>
    )
  }

  // if (popupVisible) {
  //   return (
  //     <Modal show={displayModal} onHide={handlePopupClose}>
  //       <Modal.Header closeButton>
  //         <Modal.Title>Confirm</Modal.Title>
  //       </Modal.Header>
  //       <Modal.Body>{popupText}</Modal.Body>
  //       <Modal.Footer>
  //         <Button variant='secondary' onClick={() => handlePopupClose()}>
  //           Close
  //         </Button>
  //         <Button variant='primary' onClick={() => handlePopupOk()}>
  //           {popupType === 'submit' ? 'Save Changes' : 'Reset'}
  //         </Button>
  //       </Modal.Footer>
  //     </Modal>
  //   )
  // }
  // return null
}

export { ConfirmPopup }
